/* @flow */
import React, { type Node, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RelatedRoot, RelatedCard, LabelWrapper, PriceTotal, RoundProp, PriceMeter, RelatedList } from './styles';
import Button from '../../../Button2.0';
import Pagination from '../../../UniversalPagination';
import { formatValuesNumber, getApartRoomsAndNumberString } from '../../../../utils/formatting';
import type { TSimilarAparts } from '../../../../types/apart';
import type { TRootState } from '../../../../types/rootState';

type TProps = {
	similar: Array<TSimilarAparts>,
	citySlug: string,
};

const RelatedAparts = ({ similar, citySlug }: TProps): Node => {
	const isMobile: boolean = useSelector((state: TRootState) => state.app.isMobile);
	const pageCount = Math.ceil(similar.length / 5);
	const [pageNumber, setPageNumber] = useState(0);

	const [shownSimilar, setShownSimilar] = useState(null);

	useEffect(() => {
		setShownSimilar(pageCount > 1 && similar.slice(pageNumber, 5));
	}, [similar]);

	const onPageChange = (page: number): any => {
		setPageNumber(page);
		setShownSimilar(similar.slice(page * 5, (page + 1) * 5));
	};

	return (
		<RelatedRoot>
			<RelatedList>
				{(shownSimilar || similar).map((apart) => (
					<RelatedCard key={apart.number} to={`/${citySlug}/apart/${apart.id}/`} target="_blank">
						<LabelWrapper>
							<span>{getApartRoomsAndNumberString(apart.roomsCnt, apart.number)}</span>
							{apart.areaTotal && <span>{apart.areaTotal} м²</span>}
						</LabelWrapper>
						{apart.floor && <RoundProp>{apart.floor} этаж</RoundProp>}
						{apart.priceTotalMin ? (
							<PriceTotal>{formatValuesNumber(parseInt(apart.priceTotalMin, 10), 'rub')}</PriceTotal>
						) : (
							'Цена по запросу'
						)}
						{apart.priceTotalMin / apart.areaTotal && (
							<PriceMeter>
								{formatValuesNumber(parseInt(apart.priceTotalMin / apart.areaTotal, 10), 'rubSquare')}
							</PriceMeter>
						)}

						{!isMobile && (
							<Button
								as="div"
								size="xs"
								color="secondary"
								style={{ width: '100%', textAlign: 'center', gridArea: 'button' }}
							>
								Подробнее
							</Button>
						)}
					</RelatedCard>
				))}
			</RelatedList>
			{pageCount > 1 && (
				<Pagination
					currentPage={pageNumber}
					pageChange={onPageChange}
					pageCount={pageCount}
					boundary
					justifyContent="center"
					btnBackwardLabel=""
					btnForwardLabel=""
					roundButton
					grey
					withoutBorder
				/>
			)}
		</RelatedRoot>
	);
};

export default RelatedAparts;
